import { render, staticRenderFns } from "./CursosCapacitaciones.vue?vue&type=template&id=4e26f5bd&scoped=true"
import script from "./CursosCapacitaciones.vue?vue&type=script&lang=js"
export * from "./CursosCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./CursosCapacitaciones.vue?vue&type=style&index=0&id=4e26f5bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e26f5bd",
  null
  
)

export default component.exports